import { Component, OnInit } from "@angular/core";
import { Injectable, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  UntypedFormBuilder,
} from "@angular/forms";

import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { UserdeleteComponent } from "../userdelete/userdelete.component";
import { DomSanitizer } from "@angular/platform-browser";
import { ToastService } from "src/app/services/toast.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { decryptData, encryptData } from "src/app/services/aes.service";
interface subCatModel {
  categoryId?: string;
  subCategoryId?: string;
  Name: string;
  isActive: boolean;
  createdBy?: string;
  createdOn: string;
  modifiedBy?: string;
  modifiedOn?: string;
}
@Component({
  selector: "app-subcategory",
  templateUrl: "./subcategory.component.html",
  styleUrls: ["./subcategory.component.scss"],
})
export class SubcategoryComponent implements OnInit {
  [x: string]: any;
  dataSource: any;
  subcategoryList: any;
  logoPreview: any;
  category: any;
  logo: File;
  private paginator: MatPaginator;
  // tslint:disable-next-line: variable-name
  public created_By: any;
  displayedColumns: string[] = [
    "Sno",
    "categoryId",
    "name",
    "Description",
    "edit",
    "delete",
  ];
  public validator = {
    errorMessage: "",
    UniqueSubcategory: false,
  };
  public shown = {
    grid: true,
    Form: false,
  };

  public subCategoryEdit = {
    edit: false,
  };

  Subcategory = new FormGroup({
    subcategoryId: new FormControl(),
    categoryId: new FormControl(),
    name: new FormControl(),
    description: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });
  pageIndex: number;
  pageSize: number;
  length: number;
  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    //  this.setDataSourceSubcategory();
  }
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  constructor(
    private router: Router,
    private daoService: DaoService,
    private fb: UntypedFormBuilder,
    private token: LstorageService,
    private spinner: SpinnerService,
    private _sanitizer: DomSanitizer,
    private toast: ToastService,
    public dialog: MatDialog
  ) {
    this.spinner.show();
    this.daoService.getSubcategoryList().subscribe((data: any) => {
      this.daoService.defaultSubCategoryList(data);
      this.daoService.finalSubCategoryList.subscribe(
        (subcategoryList) => (this.subcategoryList = subcategoryList)
      );

      this.dataSource = new MatTableDataSource(this.subcategoryList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });

    this.daoService.getCategory().subscribe((data) => {
      this.category = data;
      this.spinner.hide();
    });
  }
  ngOnInit() {
    this.created_By = jwtDecode(this.token.getToken());
    this.Subcategory = this.fb.group({
      subCategoryId: [""],
      categoryId: ["", [Validators.required]],
      name: ["", [Validators.required]],
      description: [""],
      isActive: [true],
      createdBy: [this.daoService.loggedUser.UserUniqueId],
      createdOn: ["2019-10-05T03:47:43.629Z"],
      modifiedBy: [this.daoService.loggedUser.UserUniqueId],
      modifiedOn: ["2019-10-10T11:17:51.838Z"],
    });
  }

  setDataSourceSubcategory() {
    this.setDataSourceSubcategory();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  SubcategoryForm() {
    this.logoPreview = "";
    this.subCategoryEdit.edit = false;
    this.shown.grid = false;
    this.shown.Form = true;
    this.Subcategory = this.fb.group({
      subCategoryId: [""],
      categoryId: ["", [Validators.required]],
      name: ["", [Validators.required]],
      description: [""],
      isActive: [true],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-10-05T03:47:43.629Z"],
      modifiedBy: [],
      modifiedOn: ["2019-10-10T11:17:51.838Z"],
    });
  }

  createSubcategory() {
    this.Subcategory.value.name = this.Subcategory.value.name.trim();
    this.validator.UniqueSubcategory = false;
    console.log("CategoryIdNw", this.Subcategory.value);
    this.daoService.AddSubcategory(this.Subcategory.value).subscribe(
      (data) => {
        this.toast.openSnackBar("SubCategory added successfully", "close");
        this.backSubcategoryList();
      },
      (error) => {
        this.validator.UniqueSubcategory = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }

  editSubcategory(id) {
    this.logoPreview = "";
    this.shown.grid = false;
    this.shown.Form = true;
    this.subCategoryEdit.edit = true;
    this.daoService.getSubcategoryById(id).subscribe((data: any) => {
      this.logoPreview = this._sanitizer.bypassSecurityTrustResourceUrl(
        "data:image/jpg;base64," + data.logo
      );
      this.Subcategory = this.fb.group({
        categoryId: [data.categoryId, [Validators.required]],
        subCategoryId: [id],
        name: [data.name, [Validators.required]],
        description: [data.description],
        modifiedBy: [this.created_By.unique_name],
      });
    });
  }

  /*deleteSubcategory(id, index) {
    this.daoService.deleteSubcategoryById(id).subscribe((data: any) => {
      this.subcategoryList = this.removeFromArrayOfHash(this.subcategoryList, 'subCategoryId', data.data.subCategoryId);
      // this.apiListofData = this.apiListofData.splice(0, index);
        this.toast.openSnackBar("SubCategory deleted successfully", 'close');
      this.dataSource = new MatTableDataSource(this.subcategoryList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

  }*/

  //DeleteSubCategory
  deleteSubcategory(id, index) {
    this.daoService.defaultsubCategoryId(id);
    this.daoService.subcategoryDelete(true);
    const dialogRef = this.dialog.open(UserdeleteComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "145px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((data) => {
      this.daoService.defaultsubCategoryId(null);
      this.daoService.subcategoryDelete(false);
      this.daoService.finalSubCategoryList.subscribe(
        (subcategoryList) => (this.subcategoryList = subcategoryList)
      );
      console.log("before sub close");
      console.log(this.subcategoryList);
      this.dataSource = new MatTableDataSource(this.subcategoryList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  backSubcategoryList() {
    this.shown.grid = true;
    this.shown.Form = false;
    this.validator.UniqueSubcategory = false;
    this.daoService.getSubcategoryList().subscribe((data: any) => {
      this.subcategoryList = data;
      this.dataSource = new MatTableDataSource(this.subcategoryList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  onfileselected(event) {
    this.logo = <File>event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.logoPreview = reader.result;
      };
    }
  }

  createtemplate() {
    this.logoPreview = "";
    this.spinner.show();
    this.validator.UniqueSubcategory = false;
    //for categoryName
    this.validator.UniqueSubcategory = false;
    //For File
    const fd = new FormData();

    if (this.logo) {
      fd.append("logo", this.logo, this.logo.name);
    }
    this.Subcategory.value.name = this.Subcategory.value.name.trim();
    const subCategoryData: subCatModel = {
      categoryId: this.Subcategory.value.categoryId,
      subCategoryId: this.Subcategory.value.subcategoryId,
      Name: this.Subcategory.value.name,
      isActive: true,
      createdOn: this.Subcategory.value.createdOn,
      modifiedOn: this.Subcategory.value.modifiedOn,
      createdBy: this.Subcategory.value.createdBy,
      modifiedBy: this.Subcategory.value.modifiedBy,
    };
    //For subCategory
    this.daoService.uploadSubCategoryLogo(subCategoryData).subscribe(
      (data: any) => {
        this.logoPreview = "";
        //if(data.IsSuccess){
        let userDetails = JSON.parse(decryptData(data.key));
        console.log("uploadSubCategoryLogoData_Subcat", userDetails);
        var data1 = {
          catId: data.categoryId,
        };
        this.daoService
          .getSubCategoryByCatId(encryptData(JSON.stringify(data1)))
          .subscribe((data: any) => {
            let data2 = JSON.parse(decryptData(data.key));
            this.toast.openSnackBar("SubCategory added successfully", "close");
            this.daoService.defaultSubCategoryList(data2);
            this.spinner.hide();
            this.backSubcategoryList();
          });
        // }
      },
      (error) => {
        this.spinner.hide();
        console.log(error);
        this.validator.UniqueSubcategory = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }
  subcategoryFilter = (value: string) => {
    this.dataSource.filter = value;
  };

  //For store pagination details
  public handlePage(e: any) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.length = e.length;
  }

  handleInput(event) {
    if (event.which === 32 && !this.Subcategory.value.name.length)
      event.preventDefault();
  }
}
